import { useEffect, useRef, useState } from "react";
import FoldedPopup from "../FoldedPopup/FoldedPopup";
import WhiteButton from "../WhiteButton/WhiteButton";
import "./ShareQuizScore.scss";

function ShareQuizScore(props) {
  const CTA_HOVER_COLOR = "#9671EC";
  const shareUrl = props.shareUrl; //"https://quizzynow.com/share/quiz/id";
  const [buttonText, setButtonText] = useState("Copy URL");

  return (
    <FoldedPopup
      enabled={props.shareQuizScoreEnabled}
      setEnabled={props.setShareQuizScoreEnabled}
      className="share-quiz-score"
      confetti={true}
      image_url={"https://quizzynow.com/uploads/mockups/mockup_quiz.png"}
      closeButton={true}
    >
      <h1>Share your awesome score!</h1>
      <p>
        You got a great score on this practice Quiz! Would you like to share it
        with your friends?
      </p>
      <div className="social-media">
        <a
          href={
            "https://twitter.com/intent/tweet?via=Quizzynow&text=" +
            encodeURI(
              "I just got an A on a practice quiz for " +
                props.set_title +
                " on Quizzy!\nSee how many tries it takes you:\n"
            ) +
            "&hashtags=quizzy%2Cquizzynow%2Ceducation%2Ceduapps%2Celearning%2Cedtech&url=" +
            shareUrl
          }
          rel="noreferrer"
          target="_blank"
        >
          <img
            src="https://quizzynow.com/uploads/twitter.png"
            alt="twitter"
          ></img>
        </a>
        <a
          rel="noreferrer"
          target="_blank"
          href={"http://www.facebook.com/share.php?u=" + encodeURI(shareUrl)}
        >
          <img
            src="https://quizzynow.com/uploads/facebook.png"
            alt="facebook"
          ></img>
        </a>
        <a
          href={
            "https://www.linkedin.com/shareArticle?url=" +
            encodeURI(shareUrl) +
            "&title=" +
            encodeURI(props.set_title) +
            "&summary=" +
            encodeURI(
              "I just got an A on a practice quiz for " +
                props.set_title +
                " on Quizzy! See how many tries it takes you:"
            ) +
            "&source=Quizzy"
          }
          rel="noreferrer"
          target="_blank"
        >
          <img
            src="https://quizzynow.com/uploads/linkedin.png"
            alt="linkedin"
          ></img>
        </a>
      </div>
      <div>
        <p style={{ fontWeight: 600 }}>Share this link</p>
        <input type="text" disabled={true} value={shareUrl}></input>
      </div>

      <WhiteButton
        text={buttonText}
        hoverColor={CTA_HOVER_COLOR}
        className="cta-btn"
        onClick={() => {
          navigator.clipboard.writeText(shareUrl);
          setButtonText("Copied!");
        }}
      ></WhiteButton>
    </FoldedPopup>
  );
}

export default ShareQuizScore;
